const BREAK_TYPE = "ssml-break";

export { BREAK_TYPE };
//# sourceMappingURL=constant.js.map
